import {useEffect, useMemo, useState} from "react";
import ProductCard from "./ProductCard";
// import "react-modern-calendar-datepicker/lib/DatePicker.css";
// import DatePicker from "react-modern-calendar-datepicker";
// import { Calendar } from "react-modern-calendar-datepicker";
// import DatePickerModal from "../../../component/global/DatePicker";
import {get} from "../../../controlers/global/ConfigRequest";
import {DISCOUNT_LIST} from "../../../helperData/ApiAddress";
import PaginationComponent from "../../../component/global/PaginationComponent";
import Spinner from "react-bootstrap/esm/Spinner";
import DBSearchFilter from "../../../component/global/DBSearchFilter";
import {useTranslation} from "react-i18next";
import DBSelectFilter from "../../../component/global/DBSelectFilter";
import {ReactComponent as TableFilter} from "../../../asset/icons/tableFiltericon.svg";
import "./style.scss";

export default function Bests({onClick}) {
  const {t} = useTranslation()
  // const [startDate, setStartDate] = useState({
  //   fa: "1390-01-01",
  //   en: "2000-01-01",
  // });
  // const [endDate, setEndDate] = useState({
  //   fa: "1410-01-01",
  //   en: "2030-01-01",
  // });
  const [filterType, setFilterType] = useState("company");

  // const [startDatePicker, setStartDatePicker] = useState(false);
  // const [endDatePicker, setEndDatePicker] = useState(false);

  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [discountCards, setDiscountCards] = useState();
  const [cardLoader, setCardLoader] = useState(false);

  const selectFilter = useMemo(() => {
    return [
      {
        value: 'company',
        title: t('Src.Pages.UserPages.UserDiscount.Bests.SelectFilter.Company')
      },
      {
        value: 'name',
        title: t('Src.Pages.UserPages.UserDiscount.Bests.SelectFilter.Name')
      },
    ]
  }, [t])

  const getDiscountList = (filter) => {
    setCardLoader(true);
    get(DISCOUNT_LIST, {
      [filterType]: filter || undefined,
      page: currentPage,
    })
      .then((r) => {
        setPageCount(r.lastPage);
        setDiscountCards(r.results);
      })
      .finally(() => {
        setCardLoader(false);
      });
  };
  useEffect(() => {
    getDiscountList();
  }, []);

  useEffect(() => {
    setFilter("");
  }, [filterType]);

  return (
    <div className="bests-main user-exchange">
      <div className="toolbar">
        <div className="toolbar-type">
          <DBSearchFilter
            placeholder={t('Src.Pages.UserPages.UserDiscount.Bests.SearchLabel')}
            value={filter}
            onClick={(value) => {
              setFilter(value)
              getDiscountList(value)
            }}
            className='bests-searchFilter'
          />
          <DBSelectFilter
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            icon={<TableFilter/>}
            data={selectFilter}
            className='bests-selectFilter'
          />
          {/*<div className="toolbar-ic pad-st-ic">*/}
          {/*  <SearchIcon/>*/}
          {/*</div>*/}
          {/*<div className="toolbar-search">*/}
          {/*  <input*/}
          {/*    type="text"*/}
          {/*    placeholder="جستجو"*/}
          {/*    value={filter}*/}
          {/*    onChange={(e) => setFilter(e.target.value)}*/}
          {/*  />*/}
          {/*</div>*/}

          {/*<select*/}
          {/*  value={filterType}*/}
          {/*  onChange={(e) => setFilterType(e.target.value)}*/}
          {/*>*/}
          {/*  <option value="company">سازمان</option>*/}
          {/*  <option value="name">نام</option>*/}
          {/*</select>*/}
        </div>
        {/*<button onClick={getDiscountList}>اعمال</button>*/}
      </div>
      <div className="discount-card-container">
        {cardLoader ? (
          <Spinner animation="border"/>
        ) : discountCards?.length === 0 ? (
          <div>{t('Src.Pages.UserPages.UserDiscount.Bests.NotFound')}</div>
        ) : (
          discountCards?.map((card, index) => (
            <ProductCard
              key={index}
              id={card.id}
              logo={card.logo}
              startDate={card.date_start}
              endDate={card.date_end}
              name={card.name}
              description={card.description}
              requiredScore={card.min_coin}
              discountCards={card.discount_cards_count}
              discountAmount={card.discount_amount}
              onClick={onClick}
            />
          ))
        )}
      </div>
      {!cardLoader && discountCards?.length && (
        <PaginationComponent
          pageCount={pageCount}
          key={currentPage}
          fetchData={(e) => console.log(e)}
          currentPage={currentPage - 1}
          setCurrentPage={(e) => setCurrentPage(e + 1)}
          feedbacks={4}
        />
      )}
    </div>
  );
}
